import { formatTimestampHuman, formatCurrency } from "../date-utils";
export const companyInvoicePaymentEmailsDtoFields = [{
        name: "dataEvento",
        title: "Data Evento",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.email.createdOn)
    }, {
        name: "sendEmail",
        title: "Esito",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            if (record.email.risultato == "OK")
                return `<span class="icon"><i class="material-icons icon-base has-text-success">check</i></span>`;
            if (record.email.risultato == "ACCODATO")
                return `<span class="icon"><i class="material-icons icon-base has-text-primary">access_time</i></span>`;
            else
                return `<span class="icon"><i class="material-icons icon-base has-text-danger">warning</i></span>`;
        }
    }, {
        name: "diagnostico",
        title: "Diagnostico",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            if (record.email.risultato == "OK")
                return ``;
            else
                return record.email.diagnostico;
        }
    }, {
        name: "tipo",
        title: "Tipo",
        render: (record) => record.email.tipoinvio
    }, {
        name: "cliente",
        title: "Cliente",
        render: (record) => record.company.name
    }, {
        name: "email",
        title: "Email",
        render: (record) => record.email.email
    }, {
        name: "numeroFattura",
        title: "N° fattura/e",
        render: (record) => {
            let nfatt = "";
            record.invoices.forEach(element => {
                nfatt += element.numeroFattura + ",";
            });
            return nfatt;
        }
    }, {
        name: "ownership",
        title: "Az. proprietaria",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.ownership.name
    }, {
        name: "importo",
        title: "Importo totale",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            let tot = 0;
            record.payments.forEach(element => {
                tot += element.importorata;
            });
            return formatCurrency(tot);
        }
    }];
